export default __webpack_public_path__ + "static/media/default.25f5e7f541e4a908e6de3a83008f2dd1.png";